module.exports = __webpack_public_path__ + "img/topup-white-admin.7ce9184d.svg";